import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Button,
  Icon
} from 'semantic-ui-react'

const CardAnesthesiaTeamUX = (props: any) => {
    return(
      <div
        id="CardAnesthesiaTeam"
        style={{width:"100%", padding: "1rem", backgroundColor: props.card === "CardBasicInfo" ? "" :"#D6ECF33B"}}>
        <div
          className="ui form"
          id="CardAnesthesiaTeamUX-div-1">
          
          <FormGroup
            id="CardAnesthesiaTeamUX-FormGroup-2"
            inline={true}>
            <FormField
              className="required"
              id="CardAnesthesiaTeamUX-FormField-4"
              inline={true}>
              <label
                id="CardAnesthesiaTeamUX-label-8"
                style={{minWidth: "90px", maxWidth: "90px"}}>
                {props.languageUX === "en" ? "Anesthesiologist" : "วิสัญญีแพทย์"}
              </label>
            </FormField>
            <FormField
              id="CardAnesthesiaTeamUX-FormField-5"
              inline={true}
              width={6}>
              <div
                id="CardAnesthesiaTeamUX-div-18"
                style={{width: "100%"}}>
                {props.AnesthesiologistElement}
              </div>
            </FormField>
            <FormField
              id="CardAnesthesiaTeamUX-FormField-17"
              inline={true}
              style={{flex:1}}>
            </FormField>
            <FormField
              id="CardAnesthesiaTeamUX-FormField-6"
              inline={true}
              style={{padding:0}}>
              <Button
                color={"red"}
                disabled={props.isDisabled? true :false}
                id="CardAnesthesiaTeamUX-Button-12"
                onClick={props.onDeleteTeam}
                style={{marginLeft: "auto"}}>
                {}
                <Icon
                  id="CardAnesthesiaTeamUX-Icon-15"
                  name={"trash"}>
                </Icon>
                <label
                  id="CardAnesthesiaTeamUX-label-16">
                  {props.languageUX === "en" ? "Delete Team" : "ลบทีม"}
                </label>
              </Button>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardAnesthesiaTeamUX-FormGroup-3">
            <FormField
              id="CardAnesthesiaTeamUX-FormField-7"
              inline={true}>
              <label
                id="CardAnesthesiaTeamUX-label-9"
                style={{minWidth: "90px", maxWidth: "90px"}}>
                {props.languageUX === "en" ? "Anesthetist nurse" : "พยาบาลวิสัญญี"}
              </label>
            </FormField>
            <FormField
              id="CardAnesthesiaTeamUX-FormField-13"
              inline={true}
              width={14}>
              <div
                id="CardAnesthesiaTeamUX-div-14"
                style={{width: "100%"}}>
                {props.AnesthetistElement}
              </div>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardAnesthesiaTeamUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Nov 20 2025 07:17:10 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeam"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", padding: \"1rem\", backgroundColor: props.card === \"CardBasicInfo\" ? \"\" :\"#D6ECF33B\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-div-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-FormGroup-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormField",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-FormField-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding:0}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "วิสัญญีแพทย์",
          "valueEN": "Anesthesiologist"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-label-8"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"90px\", maxWidth: \"90px\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "พยาบาลวิสัญญี",
          "valueEN": "Anesthetist nurse"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-label-9"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"90px\", maxWidth: \"90px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "Button",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "color": {
          "type": "code",
          "value": "\"red\""
        },
        "disabled": {
          "type": "code",
          "value": "props.isDisabled? true :false"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-Button-12"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDeleteTeam"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"auto\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "14"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.AnesthetistElement"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Icon",
      "parent": 12,
      "props": {
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-Icon-15"
        },
        "name": {
          "type": "code",
          "value": "\"trash\""
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "ลบทีม",
          "valueEN": "Delete Team"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-FormField-17"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.AnesthesiologistElement"
        },
        "id": {
          "type": "value",
          "value": "CardAnesthesiaTeamUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 18,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardAnesthesiaTeamUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
